import { LayerInfo } from "../../../../interfaces/resourceInfo";

export interface FeatureCardContextMenuProps {
  layerInfo?: LayerInfo;
  disabled?: boolean;
}

export enum ContextMenuActions {
  ZoomTo = "ZoomTo",
  Export = "Export",
  Copy = "Copy",
  Delete = "Delete",
}
